// The strap and bike trace a recorder captured, as fields for a session save
// (#188). Empty when nothing was recorded or the recorder failed: telemetry is
// auxiliary, so it never blocks the save.
export async function telemetryPayload(recorder) {
  try {
    const result = await recorder?.finalize();
    if (!result?.samples?.length) return {};
    return {
      telemetry: result.samples,
      ...(result.summary ? { telemetry_summary: result.summary } : {}),
    };
  } catch (err) {
    console.warn("[telemetry] finalize failed", err);
    return {};
  }
}
